import { render, staticRenderFns } from "./manage-dialog.vue?vue&type=template&id=38910ebe&"
import script from "./manage-dialog.vue?vue&type=script&lang=ts&"
export * from "./manage-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./manage-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports